import { render, staticRenderFns } from "./BrandMonth.vue?vue&type=template&id=7ad82e84&scoped=true"
import script from "./BrandMonth.vue?vue&type=script&lang=js"
export * from "./BrandMonth.vue?vue&type=script&lang=js"
import style0 from "./BrandMonth.vue?vue&type=style&index=0&id=7ad82e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad82e84",
  null
  
)

export default component.exports